export default {
  name: 'satisfaction-survey-modal',

  props: {
    isSurveyModalOpen: {
      type: Boolean,
      required: true
    },
    isSuccessFeedbackOpen: {
      type: Boolean,
      required: true
    },
    questions: {
      type: Array,
      required: true
    },
    surveyAnswers: {
      type: Object,
      required: true
    },
    submittedScore: {
      type: Number,
      default: null
    },
    isConfirmButtonDisabled: {
      type: Boolean,
      required: true
    },
    isSubmitting: {
      type: Boolean,
      required: true
    },
    scoreOptions: {
      type: Array,
      required: true
    },
    scoreColors: {
      type: Array,
      required: true
    },
    checkmarkIcon: {
      type: String,
      required: true
    }
  },

  computed: {
    surveyModalVisible: {
      get () {
        return this.isSurveyModalOpen
      },
      set (isVisible) {
        if (!isVisible) {
          this.closeSurveyModal()
        }
      }
    },

    feedbackModalVisible: {
      get () {
        return this.isSuccessFeedbackOpen
      },
      set (isVisible) {
        if (!isVisible) {
          this.closeSuccessFeedback()
        }
      }
    }
  },

  methods: {
    closeSurveyModal () {
      this.$emit('close-survey-modal')
    },

    selectSurveyScore (questionId, score) {
      this.$emit('select-survey-score', { questionId, score })
    },

    selectConfirmationAnswer (questionId, confirm) {
      this.$emit('select-confirmation-answer', { questionId, confirm })
    },

    updateSurveyComment (questionId, comment) {
      this.$emit('update-survey-comment', { questionId, comment })
    },

    confirmSurveyAnswer () {
      this.$emit('confirm-survey-answer')
    },

    closeSuccessFeedback () {
      this.$emit('close-success-feedback')
    },

    isSurveyScoreSelected (questionId, score) {
      return this.getQuestionAnswer(questionId).score === score
    },

    isSurveyConfirmationSelected (questionId, confirm) {
      return this.getQuestionAnswer(questionId).confirm === confirm
    },

    getScoreColor (score) {
      return this.scoreColors[score]
    },

    getQuestionAnswer (questionId) {
      return this.surveyAnswers[questionId] || {
        score: null,
        sugestion: '',
        confirm: null
      }
    },

    isScoreQuestion (question) {
      return question.type === 'nota'
    },

    isConfirmationQuestion (question) {
      return question.type === 'confirmacao'
    },

    isSuggestionQuestion (question) {
      return question.type === 'sugestao'
    },

    getQuestionText (question) {
      if (!this.isSuggestionQuestion(question) || question.required === true || question.text.includes('(opcional)')) {
        return question.text
      }

      return `${question.text} (opcional)`
    },

    getConfirmYesLabel () {
      return this.$i18n.t('yes')
    },

    getConfirmNoLabel () {
      return this.$i18n.t('no')
    }
  }
}
